const useStyles = theme => ({
    container: {
    },
    playButtonArrow: {
      fontSize: 35,
      [theme.breakpoints.only('md')]: {
        fontSize: 40,
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 25,
      },
    },
    playButton: {
      position: 'absolute',
      height: '60px',
      width: '60px',
      borderRadius: 30,
      [theme.breakpoints.only('md')]: {
        height: '58px',
        width: '58px',
      },
    },
    gradientBox: {
      opacity: 0.3,
      position: 'absolute',
      width: '100%',
      background: 'linear-gradient(to bottom, rgba(0,0,0,0.1), black)',
    },
    durationBox: {
      // Combining with the library's behavior, assigning bottom=2 creates a
      // 5px margin from the bottom.
      bottom: '2px',
      right: '5px',
      position: 'absolute',
      overflow: 'hidden',
    },
});

export default useStyles
